export const SITE_URL = "helpermemovephpr.maximquiz.com";
